import { ChangeDetectionStrategy, Component } from '@angular/core';
import { map } from 'rxjs/operators';

import {
  ISecondaryNavigationAnchorProps,
  ISecondaryNavigationNewTabAnchorProps,
  ISecondaryNavigationPulseAnchorProps,
  SecondaryNavigationBarComponentStore,
} from '../../store/secondary-navigation-bar.component-store';

@Component({
  selector: 'epc-secondary-navigation-bar',
  templateUrl: './secondary-navigation-bar.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [SecondaryNavigationBarComponentStore],
  standalone: false,
})
export class SecondaryNavigationBarComponent {
  public show$ = this.componentStore.show$;
  public items$ = this.componentStore.items$;
  public showBurgerMenuOnMobile$ = this.componentStore.config$.pipe(
    map((v) => !!v?.showBurgerMenuOnMobile),
  );

  constructor(private componentStore: SecondaryNavigationBarComponentStore) {}

  public onLinkClick(item: ISecondaryNavigationAnchorProps) {
    if ((item as ISecondaryNavigationNewTabAnchorProps)?.href) {
      return;
    }
    this.componentStore.setProductSource(
      item as ISecondaryNavigationPulseAnchorProps,
    );
  }
}
